import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=672ccade&"
import script from "./accordion-item.vue?vue&type=script&lang=js&"
export * from "./accordion-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports